
import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';

import './QuizText.css';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { ButtonWrapper } from '../LinkWrapper/LinkWrapper';
import { wrapTrademarkSuperscript } from '../../utils/cob-utils';
import { useWidthContext } from '../../providers/Width';

interface IQuizTextProps extends MappedComponentProperties {

    backgroundImageDesktop?: string;
    backgroundImageAltTextDesktop?: string;
    backgroundImageMobile?: string;
    backgroundImageAltTextMobile?: string;
    headline?: string;
    subHeadline?: string;
    ctaText?: string,
    ctaLink?: string,
  
}

export const QuizTextEditConfig = {
    emptyLabel: 'Quiz Text',
    isEmpty: (props: PropsWithChildren<IQuizTextProps>) => {
        return !props || !props.headline;
    },
};

const QuizText = (props: PropsWithChildren<IQuizTextProps>): JSX.Element => {
    const { width } = useWidthContext();
    const isMobile = width <= 768;
    const bgImg = !isMobile ? props.backgroundImageDesktop : props.backgroundImageMobile;
    const bgAltText = !isMobile ? props.backgroundImageAltTextDesktop : props.backgroundImageAltTextMobile;

    return (
        <div id='Quiz-text' className='QuizText'>
            <div className={'QuizText__background'}>
                <img src={bgImg} alt={bgAltText} />
                <div className={'QuizText__content'}>
                    <p className='QuizText__headline'>{props.headline && transformHTMLParserLinks(props.headline)}</p>
                    <p className='QuizText__subHeadline'>{props.subHeadline && transformHTMLParserLinks(props.subHeadline)}</p>
                    {props.ctaText && <ButtonWrapper className='QuizText__button' size={'large'} href={props.ctaLink}>{transformHTMLParserLinks(wrapTrademarkSuperscript(props.ctaText))}</ButtonWrapper>}
                </div>
            </div>
        </div>
    );
};

export default QuizText;
        